import React from 'react';

// Geist font family with fallbacks
const GEIST_FONT_FAMILY = '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

interface AvatarProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

interface AvatarImageProps {
  src?: string;
  alt?: string;
}

interface AvatarFallbackProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const Avatar: React.FC<AvatarProps> = ({ style, children }) => {
  const baseStyles = {
    position: 'relative' as const,
    display: 'flex',
    height: '2.5rem',
    width: '2.5rem',
    flexShrink: 0,
    overflow: 'hidden',
    borderRadius: '50%',
    ...style,
  };

  return (
    <span style={baseStyles}>
      {children}
    </span>
  );
};

export const AvatarImage: React.FC<AvatarImageProps> = ({ src, alt }) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);

  const handleLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  if (!src || imageError) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      style={{
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        display: imageLoaded ? 'block' : 'none',
      }}
      onLoad={handleLoad}
      onError={handleError}
    />
  );
};

export const AvatarFallback: React.FC<AvatarFallbackProps> = ({ style, children }) => {
  const baseStyles = {
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f3f4f6',
    color: '#6b7280',
    fontSize: '0.875rem',
    fontWeight: '500',
    fontFamily: GEIST_FONT_FAMILY,
    ...style,
  };

  return (
    <span style={baseStyles}>
      {children}
    </span>
  );
}; 